import React from 'react';
import useStyle from './tableData.style';
import { TableDataHeader } from './TableDataHeader';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';

export interface TableDataProps {
  tabLabels: Array<string>;
  children: React.ReactNode;
  noBackground?: boolean;
}

export const TableData = ({
  tabLabels,
  children,
  noBackground
}: TableDataProps) => {
  const classes = useStyle();
  return noBackground ? (
    <table className={classes.root}>
      <TableDataHeader labels={tabLabels} />
      <tbody>{children}</tbody>
    </table>
  ) : (
    <FeatureContainer>
      <table className={classes.root}>
        <TableDataHeader labels={tabLabels} />
        <tbody>{children}</tbody>
      </table>
    </FeatureContainer>
  );
};
